export const SPORTS_LOAD_SUCCESS = 'sports/LOAD_SUCCESS';
export const SPORTS_CREATE_SUCCESS = 'sports/CREATE_SUCCESS';
export const SPORTS_EDIT_SUCCESS = 'sports/EDIT_SUCCESS';
export const SPORTS_DELETE_SUCCESS = 'sports/DELETE_SUCCESS';
export const SET_BUSY = 'sports/SET_BUSY';
export const UNSET_BUSY = 'sports/UNSET_BUSY';
